import { useState, useEffect } from "react";
import CurrencyDropdown from "./CurrencyDropdown";
import ForexTab from "./ForexTab";
import RemittanceTab from "./RemittanceTab";
import CurrencyTab from "./CurrencyTab";



export default function CurrencyConverter() {
  const [activeTab, setActiveTab] = useState("currency");

  return (
    <div className="">
      <div className="w-full bg-white h-auto py-5 px-8 md:w-[30rem] rounded-lg md:pb-[1.97rem] drop-shadow-[0px_26px_27.6px_#B42330] mt-[6rem]">
        <div className="flex w-full p-[0.31rem] bg-[#FDFDFD] rounded-lg shadow-[inset_0px_1px_4.5px_0px_rgba(0,0,0,0.17)]">
          <button
            className={`w-1/3 md:py-3 py-2 text-[0.66625rem] md:text-[0.875rem] rounded-[0.25rem] ${
              activeTab === "forex" ? "bg-black text-white" : "text-[#2B2B2B]"
            }`}
            onClick={() => setActiveTab("forex")}
          >
            Forex Card
          </button>

          <button
            className={`w-1/3 md:py-3 py-2 text-[0.66625rem] md:text-[0.875rem] rounded-[0.25rem] ${
              activeTab === "remittance"
                ? "bg-black text-white"
                : "text-[#2B2B2B]"
            }`}
            onClick={() => setActiveTab("remittance")}
          >
            Remittance
          </button>

          <button
            className={`w-1/3 md:py-3 py-2 text-[0.66625rem] md:text-[0.938rem] rounded-[0.25rem] ${
              activeTab === "currency"
                ? "bg-black text-white"
                : "text-[#2B2B2B]"
            }`}
            onClick={() => setActiveTab("currency")}
          >
            Currency
          </button>
        </div>

        {activeTab === "forex" && <ForexTab />}

        {activeTab === "remittance" && <RemittanceTab />}

        {activeTab === "currency" && <CurrencyTab />}
      </div>
    </div>
  );
}
